<template>
	<input type="text" v-model.trim="keyword" class="tbl_int mm_int" :placeholder="placeholder" @keypress.enter="search()" :disabled="disabled" />
</template>

<script>
import { apiSelectItemClassStartWithKeyword } from '@/api/item/class';
export default {
	data: () => ({
		keyword: null,
	}),
	props: {
		customPlaceholder: {
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		headers() {
			return { class: this.$session.get('headerClass') };
		},
		placeholder() {
			return this.customPlaceholder || 'Search Item ' + this.headers.class + ' Code Starting with Keyword';
		},
	},
	methods: {
		async search() {
			if (!this.keyword) {
				this.$toast.error('Please, Input the Keyword for Search.');
				return;
			}

			let { data } = await apiSelectItemClassStartWithKeyword(this.keyword);
			if (!data.length) this.$toast.error(`No ${this.headers.class} Codes Starting with the Keyword.`);

			this.$emit('setClassList', data || []);
			this.keyword = null;
		},
	},
};
</script>

<style></style>
